import {i18n} from '@netx/core/i18n';
import {emptyValueSymbol} from '../constants';

export const date = (value?: any) => {
	if (
		value === emptyValueSymbol ||
		value === '' ||
		value == null ||
		value.length === 0
	)
		return true;
	return value.toString().search(/\d\d\d\d-\d\d-\d\d/) > -1
		? true
		: i18n.t('i18n.invalidDate');
};

export default date;
